import { useState, useMemo } from 'react'


import _ from 'lodash'
import Stories from 'react-insta-stories'

import { useLevelPlaySurface } from '@/shared/level-play'
import { sanitizeHtml } from '@/shared/lib/html/sanitize'
import { HandClickingAnimation } from '@/shared/ui/HandClicking'
import { AppIcon  } from '@/shared/ui/icons'
import { LevelPlay } from '@/shared/ui/LevelPlay'



export const LevelPlayStories = ({
  activity,
  step
}) => {
  const { onContinue } = useLevelPlaySurface()
  const [showHandClickAnimation, setShowHandClickAnimation] = useState(false)
  const { meta } = activity
  let stories = _.get(meta, 'stories', [])
  stories = useMemo(
    () =>
      stories.map(story => {
        if (story.kind == 'text') {
          return {
            content: () => (
              <div
                className="w-full h-full bg-white text-lg px-6 py-15"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(story?.text) }}
              />
            )
          }
        }
        if (story.kind == 'image') {
          return {
            content: () => (
              <img
                className="w-full h-full object-cover block"
                src={story?.image?.file?.url}
                alt={story.kind}
              />
            )
          }
        }
        if (story.kind == 'video') {
          return {
            url: story?.video?.file?.url,
            type: 'video'
          }
        }
      }),
    [stories]
  )

  return (
    <LevelPlay.Body id={step.id} noClasses>
      <div className="flex justify-center items-center relative h-full w-full">
        <div className="z-[1] h-full w-full absolute">
          <Stories
            height="100%"
            width="100%"
            stories={stories}
            defaultInterval={15000}
            onNext={() =>
              !showHandClickAnimation && setShowHandClickAnimation(true)
            }
            onAllStoriesEnd={() => onContinue({ uid: activity.uid })}
            progressWrapperStyles={{
              height: 6
            }}
            progressStyles={{
              height: 6
            }}
          />

          {!showHandClickAnimation && (
            <HandClickingAnimation className="absolute top-1/2 right-0 w-[75px] h-[75px] -translate-y-1/2 mr-2" />
          )}
        </div>
      </div>
    </LevelPlay.Body>
  )
}
